import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-pros-full',
  templateUrl: './pros-full.component.html',
  styleUrls: ['./pros-full.component.css']
})
export class ProsFullComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.408;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }


}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/pros-full.component.ts